import $axios, { InternalAxiosRequestConfig } from 'axios'

import {
  ACCESS_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  USER_ID_KEY,
  USER_INSTITUTION_KEY,
  USER_ROLE_KEY
} from 'src/app-constants'
import { parseToken } from 'src/utils'

import { authInterceptor } from './interceptors'

export const mainAxios = $axios.create({
  baseURL: import.meta.env.VITE_BASE_URL
})

export const pureAxios = $axios.create(mainAxios.defaults)

export const refresh = async (refreshToken: string) => {
  const userId = parseToken(localStorage.getItem(USER_ID_KEY))

  try {
    const { data: tokens } = await pureAxios.post('/api/login/refresh-token', {
      userId: userId,
      refreshToken: refreshToken,
      legalEntityId: parseToken(localStorage.getItem(USER_INSTITUTION_KEY)),
      roleId: parseToken(localStorage.getItem(USER_ROLE_KEY)) 
    })
    localStorage.setItem(ACCESS_TOKEN_KEY, `"${tokens.accessToken}"`)
    localStorage.setItem(REFRESH_TOKEN_KEY, `"${tokens.refreshToken}"`)
    return tokens.accessToken
  } catch {
    localStorage.removeItem(REFRESH_TOKEN_KEY)
    localStorage.removeItem(ACCESS_TOKEN_KEY)
    window.location.reload()
  }
}

mainAxios.interceptors.request.use(authInterceptor)
mainAxios.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    if (typeof window !== 'undefined') {
      const roleId = parseToken(localStorage.getItem(USER_ROLE_KEY))
      const institutionId = parseToken(
        localStorage.getItem(USER_INSTITUTION_KEY)
      )
      if (roleId) config.headers['Sime-Role-Id'] = roleId
      if (institutionId) config.headers['Sime-LegalEntity-Id'] = institutionId
    }

    return config
  }
)
